// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 653 ? "locale-[request]" : chunkId) + "-legacy." + {"306":"41c4b07c","379":"96e6af62","427":"b2289cdb","569":"3421f22e","653":"971d1920","686":"d1b296c0","777":"11055b71","806":"b9135657","993":"efe16ded","998":"4b76b325"}[chunkId] + ".js";
};